// extracted by mini-css-extract-plugin
export default {"hideTooltip":"C8-z","fadeIn":"D8-z","delay":"E8-z","recommendedSizeTooltip":"F8-z"};